import { Loader2 } from 'lucide-react'

interface TableProps extends React.HTMLAttributes<HTMLDivElement> { children?: React.ReactNode }

const Table = ({ children, className = '' }: TableProps) => (
  <div className="table-container"><table className={`table ${className}`}>{children}</table></div>
)

const TableHead = ({ children }: { children: React.ReactNode }) => <thead>{children}</thead>
const TableBody = ({ children }: { children: React.ReactNode }) => <tbody>{children}</tbody>
const TableRow = ({ children, className = '', onClick }: { children: React.ReactNode; className?: string; onClick?: () => void; clickable?: boolean }) => <tr className={className} onClick={onClick}>{children}</tr>

interface TableHeaderProps extends React.ThHTMLAttributes<HTMLTableCellElement> {
  sortable?: boolean; sorted?: string | null; onSort?: () => void
}
const TableHeader = ({ children, className = '', sortable = false, sorted, onSort, ...props }: TableHeaderProps) => {
  const isCenter = className.includes('text-center')
  return (
    <th className={`${sortable ? 'cursor-pointer select-none' : ''} ${className}`} onClick={sortable ? onSort : undefined} {...props}>
      <div className={`flex items-center gap-1 ${isCenter ? 'justify-center' : ''}`}>
        {children}
        {sortable && sorted && <span className="text-primary-500">{sorted === 'asc' ? '\u2191' : '\u2193'}</span>}
      </div>
    </th>
  )
}

const TableCell = ({ children, className = '', ...props }: React.TdHTMLAttributes<HTMLTableCellElement>) => <td className={className} {...props}>{children}</td>
const TableEmpty = ({ message = 'Keine Daten vorhanden', colSpan = 4 }: { message?: string; colSpan?: number }) => <TableRow><TableCell colSpan={colSpan} className="py-12 text-center text-gray-500">{message}</TableCell></TableRow>
const TableLoading = ({ loading, children }: { loading: boolean; children: React.ReactNode }) => (
  <div className="relative">{children}{loading && <div className="absolute inset-0 flex items-center justify-center bg-white/70"><Loader2 className="h-8 w-8 animate-spin text-primary-500" /></div>}</div>
)

Table.Head = TableHead
Table.Body = TableBody
Table.Row = TableRow
Table.Header = TableHeader
Table.Cell = TableCell
Table.Empty = TableEmpty
Table.Loading = TableLoading

export default Table
